import { ComponentConfig } from "@measured/puck";
import ImageField from "../../Fields/ImageField";
import ImageBlockRender from "./ImageBlockRender";

const ImageBlock: ComponentConfig<{ image: string, link: string }> = {
    fields: {
        // @ts-ignore
        image: {
            // @ts-ignore
            ...ImageField.fields.image,
            label: 'Obraz'
        },
        link: {
            type: "text",
            label: 'Link obrazka'
        },
    },
    render: (props) => (
        <ImageBlockRender {...props} />
    ),
}

export default ImageBlock;
